module.exports = __webpack_public_path__ + "static/media/Arc_desk_portfolio_image.f59a3b05.jpg";